import React, { useState } from 'react'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

function ViewContact({ contact }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>

            <OverlayTrigger
                key="top"
                placement="top"
                overlay={
                    <Tooltip id="tooltip-top">
                        View
                    </Tooltip>
                }
            >
                <img src="/images/png/view.png" onClick={handleShow} className="pointer" width={35} alt="action" />
            </OverlayTrigger>

            <Modal show={show} className='custom-modal' size='lg' centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>View Contact</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3">

                        <div className="col-12">
                            <Form.Label className='mb-0'>Name</Form.Label>
                            <p>{contact.name ? contact.name : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Email</Form.Label>
                            <p>{contact.email ? contact.email : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Phone Number</Form.Label>
                            <p>{contact.phone ? contact.phone : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Message</Form.Label>
                            <p>{contact.message ? contact.message : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Enquiry Date</Form.Label>
                            <p>{contact.createdAt ? new Date(contact.createdAt).toLocaleString() : "-"}</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ViewContact